import { render } from "./WCCartDrawerRandomWeightSelection.vue?vue&type=template&id=7322d619&ts=true"
import script from "./WCCartDrawerRandomWeightSelection.vue?vue&type=script&lang=ts"
export * from "./WCCartDrawerRandomWeightSelection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__